var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#17B31B",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7365 13.7949C29.088 14.1463 29.088 14.7162 28.7365 15.0676L17.5989 26.2052C17.4302 26.374 17.2012 26.4688 16.9625 26.4688C16.7238 26.4688 16.4949 26.374 16.3261 26.2052L11.2636 21.1427C10.9121 20.7912 10.9121 20.2214 11.2636 19.8699C11.6151 19.5184 12.1849 19.5184 12.5364 19.8699L16.9625 24.296L27.4637 13.7949C27.8152 13.4434 28.3851 13.4434 28.7365 13.7949Z",
    fill: "#17B31B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSuccess);
export default __webpack_public_path__ + "static/media/notification-success.9a9b6cccf3e03552e1e716f0032acf3a.svg";
export { ForwardRef as ReactComponent };